<template>
  <div class="mine-wrapper">
    <div class="user-info row" v-if="isLogin">
      <img v-if="userInfo.avatar.length>2" :src="userInfo.avatar" alt="Avatar" class="user-info-left avatar"  @click="goUserSettings()" />
      <img v-else src="@/images/avatar-default.svg" alt="Avatar" class="user-info-left avatar avatar-login"  @click="goUserSettings()"/>
      <div class="user-info-mid" >
        <div class="row-align-center" @click="goUserSettings()">
          <span class="nickname">{{ userInfo.nickname || userInfo.id }}
          </span>
        </div>
        <div class="identification">
          TIGA ID: {{ userInfo.id }}
          <svg
            class="icon"
            v-if="userInfo.hasCertified"
            @click="showHelp('blueTrust')"
          >
            <use xlink:href="#icon-certified-colorful" />
          </svg>
          <svg
            class="icon"
            v-if="userInfo.hasVerified"
            @click="showHelp('kyc')"
          >
            <use xlink:href="#icon-verified" />
          </svg>
        </div>
        <div class="date">
          {{ $t('mine.createdAt', { date: formatTime(userInfo.createdAt) }) }}
        </div>
      </div>
      <div class="user-info-right-wrapper">
      <svg class="user-info-right" @click="onLogoutClick">
        <use xlink:href="#icon-exit" />
      </svg>
      </div>
    </div>
    <div class="user-info row" v-else >
      <img  src="@/images/avatar-default.svg" alt="Avatar" class="user-info-left avatar"  @click="onLogInClick" />
      <div class="user-info-mid">
        <div class="nickname"  @click="onLogInClick" >{{ $t('mine.loginIn') }}
        <md-icon name="arrow-right"></md-icon>
        </div>
          <div class="identification  identification-before">
           <span class="before-login">{{ $t('global.login.agreeInfo') }}</span><a href="javascript:void(0)" @click="showAgreement()" >《{{ $t('global.login.agreementName') }}》</a>
        </div>  
      </div>
    </div>

    <tiga-notice />

    <div class="manage-item-wrapper">
       <div class="manage-item"
        v-for="(item, i) in mineLinkList"  
        :key='i'
        @click="linkTo(item)"
        >
          <svg class="field-item-icon">
            <use :xlink:href="item.icon" />
          </svg>  
          <div class="field-item-text">{{ item.text }}</div>
       </div>
    </div>

    <div class="manage-item-wrapper title-wrapper">
      {{$t('global.mine.activity')}}
    </div>
    <div class="manage-item-wrapper">
       <div class="manage-item actity-item"
        v-for="(item, i) in ActivityLinkList"  
        :key='i'
        @click="linkTo(item)"
        >
          <svg class="field-item-icon">
            <use :xlink:href="item.icon" />
          </svg>  
          <div class="field-item-text">{{ item.text }}</div>
       </div>
    </div>

    <div class="manage-item-wrapper title-wrapper">
       {{$t('global.mine.service')}}
    </div>
    <div class="manage-item-wrapper">
       <div class="manage-item"
        v-for="(item, i) in toolLinkList"  
        :key='i'
        @click="linkTo(item)"
        >
          <svg class="field-item-icon">
            <use :xlink:href="item.icon" />
          </svg>  
          <div class="field-item-text">{{ item.text }}</div>
       </div>
    </div>


    <div class="manage-item-wrapper title-wrapper">
      {{$t('global.mine.about')}}
    </div>
    <div class="manage-item-wrapper about-wrapper">
       <div class="manage-item"
        v-for="(item, i) in aboutLinkList"  
        :key='i'
        @click="linkTo(item)"
        >
          <svg class="field-item-icon about-item-icon">
            <use :xlink:href="item.icon" />
          </svg>  
          <div class="field-item-text">{{ item.text }}</div>
       </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Icon, Toast, Dialog } from 'mand-mobile';
import { loginOut } from '@/api/user';
import tigaNotice from '@/components/tiga-notice.vue';

import moment from 'moment';
export default {
  components: {
    tigaNotice,
    [Icon.name]: Icon,
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
      userInfo: state => state.userInfo,
      navLang: state => state.navLang,
      mineLinkList() {
        return [
          {
            icon: '#icon-global-user-settings',//个人设置
            text: this.$t('payInfo.name'),
            path: '/mine/payInfo',
            tag: '#icon-new',
            isShow: true,
          },
          {
            icon: '#icon-global-orders',//订单记录
            text: this.$t('mine.orders'),
            path: '/mine/orders',
            isShow: true,
          },
          {
            icon: '#icon-global-statistics',
            text: this.$t('statistics.name'),
            path: '/mine/statistics',//数据统计
            tag: '#icon-new',
            // isShow: this.userInfo.hasCertified,
            isShow: !this.userInfo.isOversea,
          },
        ].filter(item => item.isShow);
      },
      ActivityLinkList() {
        return [
          {
            icon: '#icon-global-tiga-rates',
            text: this.$t('global.tigaRatesInfo.title'),
            path: '/tigaRates',//活动费率
            isShow: true,
          },
          {
            icon: '#icon-global-rebate',
            text: this.$t('rebate.name'),
            path: '/mine/commission',//超级返佣
            isShow: true,
          },
          {
            icon: '#icon-global-green-apply',
            text: this.$t('newSettings.applyGreen.title'),
            path: '/mine/applyGreen',//蓝盾认证
            tag: '#icon-new',
            isShow: this.isLogin,
          },
        ].filter(item => item.isShow);
      },
      toolLinkList() {
        return [
          {
            icon: '#icon-global-notice-trade',
            text: this.$t('notice.title'),
            path: '/mine/notice',//智能交易
            isShow: true,
          },
          {
            icon: '#icon-global-user-manage',
            text: this.$t('customerManagement.title'),
            path: '/mine/userManage',//黑白名单
            tag: '#icon-new',
            isShow: this.userInfo.hasCertified,
          },
          {
            icon: '#icon-global-community-helper',
            text: this.$t('communityHelper.name'),
            path: '/mine/communityHelper',//社群助手
            tag: '#icon-new',
            isShow: this.userInfo.isOwner,
          },
          {
            icon: '#icon-global-message-helper',
            text: this.$t('messageHelper.name'),
            path: '/mine/messageHelper',//聊天转发
            tag: '#icon-new',
            isShow: true,
          },
        ].filter(item => item.isShow);
      },
      aboutLinkList() {
        return [
          {
            icon: '#icon-global-faq',
            text: this.$t('mine.faq'),
            handler: this.goFaq,//常见问题
            isShow: true,
          },
          {
            icon: '#icon-global-cs',
            text: this.$t('mine.customerService'),
            handler: this.showService,//客服帮助
            href: 'https://mixin.one/codes/255b9c54-b64e-4095-a789-b66506604461', //不删除直接联系个人mixin，删除则运行showService
            isShow: true,
          },
          {
            icon: '#icon-global-about',
            text: this.$t('mine.about'),//关于
            hrefObj: {
              'zh-cn': 'https://help.tigaex.com/zh',
              en: 'https://help.tigaex.com/en',
            },
            isShow: true,
          },
        ].filter(item => item.isShow);
      },
    }),
  },
  created() {
    if (this.isLogin) {
      this.$store.dispatch('updateUserInfo').catch(() => {});
    }
  },
  methods: {
    linkTo(item) {
      if (item.path) {
        return this.$router.push(item.path);
      }
      if (item.href) {
        return window.open(item.href, '_blank', 'noopener');
      }
      if (item.hrefObj) {
        return window.open(
          item.hrefObj[this.navLang],
          '_blank',
          'noopeener',
        );
      }
      if (typeof item.handler === 'function') {
        item.handler.call(item);
      }
    },
    goFaq() {
      this.$router.push('/faq');
    },
    showAgreement() {
      var hrefObj = { 
        'zh-cn': 'https://help.tigaex.com/en/service-terms.html',
        en: 'https://help.tigaex.com/en/service-terms.html',
      };
      window.open(
        hrefObj[this.navLang],
        '_blank',
        'noopeener',
      );
    },
    goUserSettings() {
      this.$router.push('/mine/payInfo');
    },
    showService() {
      Dialog.confirm({
        title: this.$t('orderDetail.assistance'),
        cancelText: this.$t('common.cancel'),
        confirmText: this.$t('common.sendMessage'),
        onConfirm: () => {
          // 打开 local 机器人
          window.location.href = 'mixin://users/1906a44a-d9eb-4d22-b4c7-b46a85969d5c';
        },
      });
    },
    onLogInClick() {
      this.$router.push('/login');
    },
    onLogoutClick() {
      Dialog.confirm({
        title: this.$t('global.logoutInfo'),
        cancelText: this.$t('common.cancel'),
        confirmText: this.$t('common.confirm'),
        onConfirm: () => {
          //
          loginOut()
            .then(() => {
              this.$store.commit('setUserInfo', { isLogin: false });
              Toast.succeed(this.$t('mine.exitSuccess'));
            })
            .catch(err => {
              Toast.failed(`${this.$t('error.occur')}${err.message}`);
            });
        },
      });
    },
    showHelp(type) {
      let title = '';
      let icon = 'warn';
      let iconSvg = false;
      switch (type) {
        case 'kyc':
          icon = 'icon-verified';
          iconSvg = true;
          title = this.$t('mine.what_is_kyc');
          break;
        case 'blueTrust':
          icon = 'icon-certified-colorful';
          iconSvg = true;
          title = this.$t('mine.what_is_blue_trust');
          break;
      }
      Dialog.alert({
        icon: icon,
        iconSvg: iconSvg,
        content: title,
        confirmText: this.$t('common.known'),
      });
    },
    formatTime(unix) {
      return moment(unix).format('YYYY/MM/DD');
    },
  },
};
</script>

<style lang="stylus" scoped>

.user-info {
  box-sizing: border-box;
  padding: 3vw 4.8vw;
  height: 22vw;
  background-color: #fff;

  .user-info-left {
    box-sizing: border-box;
    flex: 0 0 16vw;
    height: 16vw;
    border: 0.27vw solid #fff;
    border-radius: 31.8%;
  }

  .user-info-mid {
    width: 58vw;
    padding: 0 3.8vw;
    display: flex;
    flex-direction: column;
    position:relative;

    .nickname {
      font-size: 3.88vw;
      font-weight: bold;
      max-width: 48vw;
      word-ellipsis();
      .md-icon {
        font-size:3.88vw;
      }
    }

    .icon {
      margin-left: 1.07vw;
      width: 3.28vw;
      height: 3.28vw;
    }

    .identification-before{
       display: block !important;
    }

    .identification {
      display:inline-flex;
      margin-top: 1.07vw;
      font-size: 2.68vw;
        .before-login{
          color: #7f7f87
        }
        a {
          color: color-primary;
          text-decoration:none;
        }
    }

    .date {
      position: absolute;
      bottom:0;
      margin-top: 2.13vw;
      font-size: 2.13vw;
      color: #BCC7CB;
    }
  }
  .user-info-right-wrapper {
    width: 6.4vw;
    height: 6.4vw;
    align-self:center;
  }
  .user-info-right {
    width: 6.4vw;
    height: 6.4vw;
  }
}

.manage-item-wrapper   
  display:flex;
  flex-direction:row;
  padding: 2vw 4.8vw;
  .manage-item 
    width:22.58vw;
    display: flex;
    flex-direction: column;
    align-items:center;
    svg 
      width: 5.18vw;
      height: 5.18vw;
      color: color-primary;
      margin-bottom: 3.18vw;
  .field-item-text
      font-size:2.98vw;
      text-align:center;

.title-wrapper  
  border-top: 2.13vw solid #F8FBFC;
  font-weight:bold;
  font-size: 3.28vw;

.actity-item .field-item-icon
  color: color-primary;

.about-wrapper 
  padding-bottom: 18vw;
.about-item-icon 
  color: #2c3133 !important;
</style>
